import { SnakeCasedPropertiesDeep } from 'type-fest';
import * as v from 'valibot';
import type { query_recursive_types as RpcRecursiveTypes } from '~/infra/api/rpc';
import { ContestStatus, convertContestStatus } from './contest-status';

type ContestResponse =
  SnakeCasedPropertiesDeep<RpcRecursiveTypes.IContestResponse>;

export const ContestListItemSchema = v.object({
  id: v.string(),
  status: v.enum(ContestStatus),
  name: v.string(),
  description: v.string(),
  discloseAt: v.optional(v.date()),
  openEntryAt: v.optional(v.date()),
  closeEntryAt: v.optional(v.date()),
  announceResultAt: v.optional(v.date()),
  thumbnailUrl: v.optional(v.string()),
});

export type IContestListItem = v.InferOutput<typeof ContestListItemSchema>;

// 時刻がnilの場合の値
const EMPTY_TIME_STAMP = '0001-01-01T00:00:00Z';

export const parseDate = (date: string | undefined): Date | undefined => {
  if (date === EMPTY_TIME_STAMP || typeof date !== 'string') {
    return;
  }
  return new Date(date);
};

/**
 * @throws {v.ValiError}
 */
export const convertContestResponseToIContestListItem = (
  data: ContestResponse
): IContestListItem => {
  return v.parse(ContestListItemSchema, {
    id: data.id,
    status: convertContestStatus(data.status),
    name: data.name ?? '',
    description: data.description ?? '',
    discloseAt: parseDate(data.disclose_at),
    openEntryAt: parseDate(data.open_entry_at),
    closeEntryAt: parseDate(data.close_entry_at),
    announceResultAt: parseDate(data.announce_result_at),
    thumbnailUrl: data.thumbnail?.serving_url ?? undefined,
  });
};

export const convertContestResponseToIContestListItemOrUndefined = (
  data: ContestResponse
): IContestListItem | undefined => {
  try {
    return convertContestResponseToIContestListItem(data);
  } catch (error) {
    console.error('IContestListItem convert error:', error);
    return undefined;
  }
};
